import type { QueryApi } from "../../api/query";

export function createUseMainCategoriesWithCounts($api: QueryApi) {
  return function useMainCategoriesWithCounts(options?: { staleTime?: number }) {
    return $api.useQuery("get", "/categories/main-with-counts", {}, {
      staleTime: options?.staleTime ?? 5 * 60_000,
    });
  };
}
